import { render, staticRenderFns } from "./AlgoFields.vue?vue&type=template&id=01e3086d"
import script from "./AlgoFields.vue?vue&type=script&lang=ts"
export * from "./AlgoFields.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports